module.exports = __webpack_public_path__ + "static/img/yinyuming.f7ed7dfc.jpg";